module.exports = __webpack_public_path__ + "img/blockchain_sm.c3e09e92.png";